import React from "react";
import PropTypes from "prop-types";
import Typography from "./ui/Typography";

const BrowsePageIntro = ({
  id,
  variant = "month",
  title,
  description,
  actions = null,
  children = null,
  descriptionClassName = "reading-measure",
}) => (
  <section className={`browse-page-intro browse-page-intro--${variant}`} aria-labelledby={id}>
    <div className="browse-page-intro__copy">
      <Typography id={id} as="h1" variant="h2" className="text-foreground">
        {title}
      </Typography>
      <Typography variant="body" className={`${descriptionClassName} text-muted-foreground sm:text-body-large`}>
        {description}
      </Typography>
    </div>

    <div className="browse-page-intro__aside">
      {actions ? <div className="browse-page-intro__actions">{actions}</div> : null}
      {children}
    </div>
  </section>
);

BrowsePageIntro.propTypes = {
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["month", "archive"]),
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  actions: PropTypes.node,
  children: PropTypes.node,
  descriptionClassName: PropTypes.string,
};

export default BrowsePageIntro;
